<template>
  <div>
    <Spinner v-if="isLoading" size="medium" />
    <div v-if="!isLoading" class="va-row">
      <div class="flex md12 xs12">
        <vuestic-widget>
          <div class="va-row">
            <div class="flex">
              <button class="btn btn-primary btn-micro" @click="updateUserData">
                {{ "basic.button.confirm" | translate }}
              </button>
            </div>
            <div class="flex">
              <button class="btn btn-pale btn-micro" @click="$router.back(-1)">
                {{ "basic.button.cancel" | translate }}
              </button>
            </div>
          </div>
        </vuestic-widget>
      </div>
      <div class="va-row">
        <div class="flex md12 xs12">
          <!-- User Infomation -->
          <vuestic-widget
            :headerText="'userManagement.user.userInfomation.title' | translate"
          >
            <fieldset>
              <div class="va-row">
                <div class="s-item">
                  <label>{{ $t("forms.wizard.name") }}：</label>
                  <span>{{ userForm.name }}</span>
                </div>
                <div class="s-item">
                  <label>{{ $t("auth.email") }}：</label>
                  <span>{{ userForm.email }}</span>
                </div>
              </div>
            </fieldset>
          </vuestic-widget>

          <!-- Authority -->
          <vuestic-widget
            :headerText="'userManagement.user.authority.title' | translate"
            id="formAuthority"
          >
            <fieldset>
              <!-- Pages -->
              <div class="flex md12 xs12">
                <div
                  style="border-width: 0px 0px 1px 0px; border-style: solid; border-color: rgba(204, 204, 204, 1);"
                >
                  <span>{{
                    "userManagement.user.authority.pages.title" | translate
                  }}</span>
                </div>
              </div>
              <div
                class="flex md12 xs12"
                v-for="(page, index) in userForm.pages"
                :key="index"
              >
                <!-- Page List -->
                <div class="va-row">
                  <!-- <div class="flex md2" /> -->
                  <div class="flex md4 p-l">
                    <label>{{ translatePageName(page.name) }}</label>
                  </div>
                  <div class="flex md2" />
                  <div class="flex md4">
                    <!-- <el-checkbox-group v-model="userForm.pages[index].privileges">
                  <el-checkbox-button border v-for="p in privilege" :label="p" :key="p">{{p}}</el-checkbox-button>
                </el-checkbox-group> -->
                    <vuestic-checkbox
                      :label="$t('view')"
                      style="display:inline-flex;width:100px;"
                      v-model="createItems[index].privileges[0]"
                    />
                    <!-- <vuestic-checkbox
                  label="Edit"
                  style="display:inline-flex;"
                  v-model="createItems[index].privileges[1]"
                /> -->
                  </div>
                  <div class="flex md2" />
                </div>
              </div>

              <!-- APPs -->
              <div class="flex md12 xs12">
                <div
                  style="border-width: 0px 0px 1px 0px; border-style: solid; border-color: rgba(204, 204, 204, 1);"
                >
                  <span>{{
                    "userManagement.user.authority.apps.title" | translate
                  }}</span>
                </div>
              </div>
              <div class="va-row">
                <div class="flex md1 xs1"></div>
                <!-- APP List -->
                <div class="flex md10 xs10">
                  <vuestic-multi-select
                    :label="$t('userManagement.user.authority.apps.selectDuplicate')"
                    v-model="selectApps"
                    optionKey="app_name"
                    clearable
                    :options="appList"
                  />
                  <!-- <el-checkbox-group v-model="userForm.linked_apps" class="p-l">
                <el-checkbox v-for="app in appList" :label="app.app_id" :key="app.app_id">{{app.app_name}}</el-checkbox>
              </el-checkbox-group> -->
                  <div class="flex md1 xs1"></div>
                </div>
              </div>
            </fieldset>
          </vuestic-widget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/utils";
import { translatePageName as mapPageName } from "@/utils/pageNameLabel";
import Spinner from "vue-simple-spinner";
import pageName from "./pageNames";
export default {
  name: "EditUser",
  components: { Spinner },
  data() {
    return {
      userForm: {
        name: "",
        email: "",
        password: "",
        repeat_password: "",
        pages: [
          // {
          //   name: pageName.transactions,
          //   privileges: []
          // },
          {
            name: pageName.report,
            privileges: []
          },
          {
            name: pageName.appManagement,
            privileges: []
          },
          {
            name: pageName.finance,
            privileges: []
          },
          {
            name: pageName.virtualAccount,
            privileges: []
          },
          // {
          //   name: pageName.merchantKyc,
          //   privileges: []
          // },
          {
            name: pageName.wayBill,
            privileges: []
          },
          {
            name: pageName.download,
            privileges: []
          }
        ],
        linked_apps: []
      },
      isLoading: true,
      appList: [],
      selectApps: [],
      privilege: ["View", "Edit"],
      token: localStorage.getItem("Authorization"),
      detailItem: JSON.parse(sessionStorage.getItem("itemObj")) || {},
      uid: "",
      createItems: [
        // {
        //   name: pageName.transactions,
        //   privileges: [false]
        // },
        {
          name: pageName.report,
          privileges: [false]
        },
        {
          name: pageName.appManagement,
          privileges: [false]
        },
        {
          name: pageName.finance,
          privileges: [false]
        },
        {
          name: pageName.virtualAccount,
          privileges: [false]
        },
        // {
        //   name: pageName.merchantKyc,
        //   privileges: [false]
        // },
        {
          name: pageName.wayBill,
          privileges: [false]
        },
        {
          name: pageName.download,
          privileges: [false]
        }
      ]
    };
  },
  created() {
    this.userForm.name = this.detailItem.real_name;
    this.userForm.email = this.detailItem.nick_name;
    this.uid = this.detailItem.uid;
    this.getAppList();
  },
  beforeMount() {
    if (process.env.VUE_APP_WEBSETE_SIGN === 'lt') {
      this.userForm.pages = this.userForm.pages.filter(page => (page.name !== pageName.virtualAccount && page.name !== pageName.wayBill))
      this.createItems = this.createItems.filter(item => (item.name !== pageName.virtualAccount && item.name !== pageName.wayBill))
    }
  },
  mounted() {
    //this.getAppList()
  },

  methods: {
    translatePageName(name) {
      return mapPageName(this, name);
    },
    getPermissions() {
      let urls =
        "api/dashboard/app/user/permissions?access_token=" +
        this.token +
        "&query_uid=" +
        this.uid;
      request({
        method: "post",
        url: urls
      }).then(res => {
        if (res.data.code == 10000) {
          this.isLoading = false;

          res.data.data.permission.forEach(item => {
            this.createItems.forEach((i, index) => {
              if (i.name === item.name) {
                this.createItems[index].privileges = [
                  item.privileges[0] === "View" ? true : false,
                  item.privileges[1]
                ];
              }
            });
          });

          setTimeout(() => {
            this.selectApps = this.appList.filter(item => {
              return res.data.data.apps.some(i => i === item.app_id);
            });
          }, 200); // in order to pre-selected items effect on multiple selection box we've deleyed seletApps
        } else if (res.data.code == 20001) {
          this.$message({
            duration: 1200,
            message: "Request Unauthorized!",
            type: "error"
          });
        } else {
          this.$message({
            duration: 1200,
            message: "Opps something went wrong :(",
            type: "error"
          });
        }
        //console.log("res",res)
      });
    },
    getAppList() {
      let urls =
        "api/dashboard/merchant/getMerchantInfo?access_token=" + this.token;
      request({
        method: "post",
        url: urls
      }).then(res => {
        this.appList = res.data.app_list;
        this.getPermissions();
      });
    },

    updateUserData() {
      this.userForm.pages = this.createItems.map(item => {
        return {
          ...item,
          privileges: [
            item.privileges[0] ? "View" : "",
            item.privileges[1] ? "Edit" : ""
          ]
        };
      });
      this.userForm.linked_apps = this.selectApps.map(item => {
        return item.app_id;
      });
      let urls = `api/dashboard/app/user/update?access_token=${
        this.token
      }&update_uid=${this.uid}`;
      let data = JSON.stringify(this.userForm);
      request({
        method: "post",
        url: urls,
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      })
        .then(res => {
          if (res.data.code == 10000) {
            this.$message({
              duration: 1200,
              message: "Successfuly Updated!",
              type: "success"
            });
          } else if (res.data.code == 20001) {
            this.$message({
              duration: 1200,
              message: "Request Unauthorized!",
              type: "error"
            });
          } else {
            this.$message({
              duration: 1200,
              message: "Opps something went wrong :(",
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            duration: 1200,
            message: "Opps something went wrong :(",
            type: "error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.p-l {
  padding-left: 40px !important;
}
/deep/ .el-checkbox__label {
  font-size: 1rem;
}
/deep/ .el-checkbox__inner {
  width: 22px;
  height: 22px;
  border-radius: 0.25rem;
  border: solid 0.125rem #acb5be;
  &:hover {
    border-color: #acb5be;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 9px;
    border-width: 2px;
  }
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ae387;
  border-color: #4ae387;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
  font-weight: 500;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #acb5be;
}
/deep/ .valid.form-group .control-label.control-label {
  color: #b3b3b3;
  position: absolute;
  top: 8px;
  text-transform: none;
  font-size: 16px;
  font-weight: normal;
  pointer-events: none;
}
.control-label2 {
  color: #4ae387;
  position: absolute;
  top: -10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
}
/* /deep/ .valid.form-group #newEmail.control-label.control-label {
  top: 0.25rem; // -10px;
  color: #b3b3b3; // #4ae387;
  font-size: 14px;
  font-weight: 600;
} */
@media only screen and (max-width: 750px) {
  /deep/ #formAuthority.vuestic-widget {
    .vuestic-widget-body {
      padding: 0.5rem;
      fieldset label {
        width: 120px;
        padding-left: 10px;
      }
    }
  }

  .p-l {
    padding-left: 0 !important;
  }
}
/deep/ .scrollbar-wrapper {
  height: 200px !important;
  // overflow-y: scroll;
}
#formAuthority {
  padding-bottom: 80px;
}
.s-item {
  width: 40%;
}
.s-item label {
  margin-left: 50px;
  margin-right: 20px;
}
</style>
